<template>
  <div class="field-wrapper">
    <slot></slot>
    <slot name="input"></slot>
    <slot name="icon"></slot>
    <div class="errors-wrapper">
      <div class="errors">
        <slot name="errors"></slot>
      </div>
    </div>
    <slot name="button"></slot>
  </div>
</template>

<script>
export default {
  name: "field-wrapper"
};
</script>

<style lang="scss">
@import "./../../assets/scss/vars";
$highlightColor: rgba(117, 154, 221, 0.3);
$highlightErrorColor: rgba(255, 74, 77, 0.35);

.field-wrapper {
  label {
    cursor: pointer;
    white-space: nowrap;
  }

  input,
  select,
  textarea {
    display: block;
    width: 100%;
    color: #000;
    border: 2px solid $gray7;
    padding: 1rem;
    text-align: left;
    appearance: none;
    transition: background-color 0.2s, border-color 0.2s;

    &.invalid,
    &[aria-invalid="true"] {
      border-color: $error;

      &:focus{
        outline: 0.2rem solid lighten($error, 50);
      }
    }

    &[readonly] {
      filter: grayscale(100%);
      opacity: 0.3;
    }

    &[type="checkbox"] {
      visibility: hidden;
      position: absolute;
    }

    &:not(last-child) {
      margin-bottom: 1em;
    }

    &.dirty,
    &:focus {
      outline: 0.2rem solid lighten($gray7, 25);
    }
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.field-wrapper {
  margin-bottom: 2.5rem;
  width: 100%;
  position: relative;

  .errors-wrapper {
    color: #da9da0;
    margin-top: 0.5rem;
    position: absolute;
    left: 0;
    top: 100%;
    width: 100%;
    white-space: nowrap;
    text-align: left;
    font-size: 0.85rem;
  }

  &:last-child {
    margin-bottom: 0;
  }

  .field-icon {
    position: absolute;
    top: 50%;
    right: 15px;
    pointer-events: none;
    transform: translateY(-50%) rotate(0);
    transition: all 0.5s;
  }

  select {
    &:focus {
      ~ .field-icon {
        transform: translateY(-50%) rotate(180deg);
      }
    }
  }
}
</style>
